import React from 'react'
import { Modal } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

function ImageModal(props) {
    const { image, show, handleClose } = props;
    return (
        <Modal show={show} onHide={handleClose} centered style={{ backgroundColor: '#f0e7da' }}>
            <Modal.Body className="p-0" style={{ backgroundColor: '#f0e7da' }}>
                <div className="card border border-0" style={{ backgroundColor: '#f0e7da' }}>
                    <img src={image} className="card-img-top img-fluid" alt="..."></img>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ImageModal;